<i18n
  src="@/locales/views/customer/reporting/container/list_reports.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="customer_reporting_container_list_containers_path"
    :params="{
      customer_id: customer_id,
      agro_exporter_id: agro_exporter_id,
      agro_exporter_process_id: agro_exporter_process_id
    }"
  />

  <bread-crumbs
    :labels="[
      module_name,
      agro_exporter?.name,
      agro_exporter_process?.name,
      container?.container_code
    ]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <container-info v-if="container" :container="container" />

    <h1 class="page-title mt-8">
      <i class="fa-solid fa-box-check"></i><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="mt-8 flex flex-col">
      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul role="list" class="divide-y divide-slate-200">
          <li v-for="report in quality_template_main_reps" :key="report.id">
            <div
              class="block hover:bg-slate-50 cursor-pointer"
              @click.prevent="goToShowTemplateMainRep(report)"
            >
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <p class="text-sm font-medium text-gray-900 truncate">
                    {{ report.name }}
                  </p>
                  <div class="ml-2 flex-shrink-0 flex">
                    <a class="link invisible sm:visible">
                      <i class="fa-solid fa-eye"></i>
                      <span class="space-icon"></span>
                      {{ $t("labels.show_link") }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li v-for="report in customer_reports" :key="report.id">
            <div
              class="block hover:bg-slate-50 cursor-pointer"
              @click.prevent="goToShowCustomerReport(report)"
            >
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <p class="text-sm font-medium text-gray-900 truncate">
                    {{ report.name }}
                  </p>
                  <div class="ml-2 flex-shrink-0 flex">
                    <a class="link invisible sm:visible">
                      <i class="fa-solid fa-eye"></i>
                      <span class="space-icon"></span>
                      {{ $t("labels.show_link") }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/customer/requesters/reporting/container/list_reports.js";
import ContainerInfo from "@/components/views/customer/reporting/ContainerInfo.vue";

export default {
  name: "CustomerReportingContainerListReports",
  components: { ContainerInfo },
  data() {
    return {
      load_data_general: false,
      agro_exporter: {},
      agro_exporter_process: {},
      container: {},
      quality_template_main_reps: [],
      customer_reports: []
    };
  },
  props: {
    customer_id: { required: true },
    agro_exporter_id: { required: true },
    agro_exporter_process_id: { required: true },
    container_id: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchAgroExporter();
        this.fetchAgroExporterProcess();
        this.fetchContainer();
        this.fetchQualityTemplateMainReps();
        this.fetchCustomerReports();
        this.load_data_general = true;
      })
    );
  },
  methods: {
    fetchAgroExporter: async function () {
      let response = await Requester.fetchAgroExporter(
        this.customer_id,
        this.agro_exporter_id
      );
      this.agro_exporter = response.data;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.customer_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer(
        this.customer_id,
        this.container_id
      );
      this.container = response.data;
    },
    fetchQualityTemplateMainReps: async function () {
      let response = await Requester.fetchQualityTemplateMainReps(
        this.customer_id,
        this.container_id
      );

      this.quality_template_main_reps = response.data;
    },
    fetchCustomerReports: async function () {
      let response = await Requester.fetchCustomerReports(
        this.customer_id,
        this.agro_exporter_process_id
      );

      this.customer_reports = response.data;
    },
    goToShowTemplateMainRep: function (quality_template_main_rep) {
      this.$router.push({
        name: "customer_reporting_container_show_template_main_rep_path",
        params: {
          customer_id: this.customer_id,
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
          quality_template_main_rep_id: quality_template_main_rep.id
        }
      });
    },
    goToShowCustomerReport: function (customer_report) {
      this.$router.push({
        name: "customer_reporting_container_show_customer_report_path",
        params: {
          customer_id: this.customer_id,
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
          customer_report_id: customer_report.id
        }
      });
    }
  }
};
</script>
